/**
 * Coups de pouce, Attendus 1239 « donner la nature d'une face d'une
 * pyramide représentée en perspective cavalière » et 1240 « identifier
 * les patrons de pyramides données » (3e, Espace). Seconde passe 3e
 * (2026-09-13). UNE page STATIQUE par attendu, dessinée avec les figures
 * des cartes elles-mêmes (svgPyramideNommee, patronPyramide) : l'image que
 * l'élève a déjà.
 *   1239 « Des triangles autour de la base » : la pyramide SABC à base
 *     triangulaire (HORS plage des cartes : carré, rectangle, hexagone).
 *     Toute face qui passe par le sommet S est un triangle ; la base est la
 *     seule face qui ne passe pas par S, sa nature est celle du polygone
 *     de base.
 *   1240 « Autant de triangles que de côtés » : le patron d'une pyramide à
 *     base pentagonale (n = 5, HORS plage : 3, 4, 6 côtés). Cinq côtés,
 *     cinq triangles, un collé sur chaque côté de la base ; un patron qui en
 *     a trop, pas assez, ou deux sur le même côté ne se replie pas.
 *
 * Pas de sacrifice : les deux exemples sont hors des tirages (vérifié par
 * cdp3e-lot3.self.test.js : jamais de base triangulaire en 1239, jamais
 * n = 5 en 1240).
 */
import { svg } from './1054';
import { svgPyramideNommee } from '../maths/3eme/espace/pyramide';
import { patronPyramide } from '../maths/4eme/espace/svgEspace';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
/** Le contenu d'un <svg> de gen (sans son enveloppe), pour le placer dans la page. */
const interieur = (s) => String(s).replace(/^<svg[^>]*>/, '').replace(/<\/svg>\s*$/, '');

// ─── 1239 : la pyramide SABC ───────────────────────────────────────────────

const PYRAMIDE = interieur(svgPyramideNommee({ base: 'triangle', sommet: 'S', lettres: ['A', 'B', 'C'] }));

const SVG_FACES = svg(
    'Une pyramide S A B C à base triangulaire en perspective cavalière. La face S A B, qui passe par le sommet S, est un triangle, comme toutes les faces qui passent par S. La base A B C est la seule face qui ne passe pas par S : ici un triangle ; dans une autre pyramide, un carré, un rectangle ou un hexagone.',
    `<g transform="translate(20, 4) scale(0.78)">${PYRAMIDE}</g>
  <text x="270" y="70" font-size="12" font-weight="bold" fill="${ORANGE}">faces SAB, SBC, SAC :</text>
  <text x="270" y="86" font-size="12" fill="${ORANGE}">des triangles, elles</text>
  <text x="270" y="102" font-size="12" fill="${ORANGE}">passent par S</text>
  <text x="270" y="136" font-size="12" font-weight="bold" fill="${BLEU}">la base ABC :</text>
  <text x="270" y="152" font-size="12" fill="${BLEU}">la seule face sans S</text>
  ${ligne(204, `Une face qui passe par <tspan fill="${ORANGE}" font-weight="bold">S</tspan> est toujours un triangle.`, 13)}
  ${ligne(226, `La <tspan fill="${BLEU}" font-weight="bold">base</tspan> a la nature de son polygone : triangle, carré, rectangle, hexagone.`, 12)}
  ${ligne(248, 'Je regarde si la face passe par S ou non.', 12, GRIS)}`,
    264,
);

// ─── 1240 : le patron à base pentagonale ───────────────────────────────────

const PATRON = interieur(patronPyramide(5, 'correct', { vb: { w: 200, h: 200 } }));

const SVG_PATRON = svg(
    'Le patron d’une pyramide à base pentagonale : un pentagone bleu au centre, cinq triangles autour, un collé sur chaque côté. Cinq côtés, cinq triangles. Un triangle sur chaque côté de la base, jamais deux sur le même, jamais un côté sans triangle.',
    `<g transform="translate(20, 0) scale(0.9)">${PATRON}</g>
  <text x="262" y="60" font-size="13" font-weight="bold" fill="${BLEU}">la base : 5 côtés</text>
  <text x="262" y="92" font-size="13" font-weight="bold" fill="${ORANGE}">5 triangles autour,</text>
  <text x="262" y="108" font-size="12" fill="${ORANGE}">un par côté</text>
  ${ligne(206, 'Autant de triangles que de côtés de la base.', 13)}
  ${ligne(228, 'Un triangle collé sur chaque côté, jamais deux sur le même côté.', 12)}
  ${ligne(250, 'Sinon, en repliant, il manque une face ou deux se chevauchent.', 12, GRIS)}`,
    266,
);

const AIDE_FACES = { pages: [{ titre: 'Des triangles autour de la base', svg: SVG_FACES }] };
const AIDE_PATRON = { pages: [{ titre: 'Autant de triangles que de côtés', svg: SVG_PATRON }] };

const CP_1239 = {
    nature_qcm_unique: AIDE_FACES,
    nature_tableau_vf: AIDE_FACES,
    face_qcm_unique: AIDE_FACES,
};
export const CP_1240 = {
    patron_qcm_unique: AIDE_PATRON,
    estpatron_qcm_unique: AIDE_PATRON,
    flash_texte_trou_saisie: AIDE_PATRON,
    sens_tableau_vf: AIDE_PATRON,
};

export default CP_1239;
